module.exports = __webpack_public_path__ + "static/media/history.e85ab31e.svg";